class ApiFetcher {

    constructor() {
        this.errors = [];
        this.token = document.querySelector('meta[name="csrf-token"]')['content']
        this.headers = {
            "Content-Type": "application/json",
            // 'Content-Type': 'application/x-www-form-urlencoded',
            "Accept": "application/json, text-plain, */*",
            "X-Requested-With": "XMLHttpRequest",
            "X-CSRF-TOKEN": this.token,
        };
    }

    addHeaders(additionalHeaders) {
        this.headers = {
            ...this.headers,
            ...additionalHeaders,
        };
    }

    get(url = '', data = {}) {
        if (_.keys(data).length > 0) {
            url = url + '?' + new URLSearchParams(data)
        }
        return this.getData(url, null, 'get');
    }

    post(url = '', data = {}) {
        return this.getData(url, data, 'post');
    }

    async getData(url = '', data = {}, method = 'post') {
        this.errors = [];
        this.controller = new AbortController(); // this.controller.abort();
        const signal = this.controller.signal
        // Default options are marked with *
        const params = {
            method: method.toUpperCase(), // *GET, POST, PUT, DELETE, etc.
            signal: signal, // This is our AbortSignal
            mode: 'same-origin', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: this.headers,
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *client
        }
        if (data) {
            params.body = JSON.stringify(data) // body data type must match "Content-Type" header
        }
        const response = await fetch(url, params);

        if (!response.ok) {
            const answer = await response.json();
            this.errors.push({
                method: params.method,
                url: url,
                data: data,
                response: {
                    ok: response.ok,
                    redirected: response.redirected,
                    status: response.status + ' ' + response.statusText,
                    answer: answer,
                },
            });
            console.log(answer);

            throw new Error(`${url} refused with status ${response.status}`);
        }

        return await response.json();
    }

    notify(message, type, engine = 'alpinejs') {

        if (engine === 'alpinejs') {
            switch(type) {
                case 'error':
                    Alpine.store('alerts').error(message);
                    break;
                case 'danger':
                    Alpine.store('alerts').danger(message);
                    break;
                case 'warning':
                    Alpine.store('alerts').warning(message);
                    break;
                case 'success':
                    Alpine.store('alerts').success(message);
                    break;
                default:
                    Alpine.store('alerts').addMessage(type, type, message);
            }

        }
    }

    hasError(response, engine = 'alpinejs') {
        if (response.error) {
            let message = '';
            if (response.error.message) {
                message = response.error.message;
                if (parseInt(response.error.code) === 422 && response.data) {
                    _.forEach(response.data, (value, key) => {
                        message = message + "\n" + key + ': ' + value;
                    });
                }
            }
            this.notify(message, 'error', engine);

            return true;
        }

        return false;
    }
}

export default ApiFetcher;
